<template>
    <TableLayout :permissions="['renthouse:rhcityinfo:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="城市名称" prop="cityName">
                <el-input v-model="searchForm.cityName" placeholder="请输入城市名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="城市编码" prop="cityCode">
                <el-input v-model="searchForm.cityCode" placeholder="请输入城市编码" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['renthouse:rhcityinfo:create', 'renthouse:rhcityinfo:delete']">
                <li><el-button type="primary" @click="$refs.operaRhCityInfoWindow.open('新建城市')" icon="el-icon-plus" v-permissions="['renthouse:rhcityinfo:create']">新建</el-button></li>
                <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['renthouse:rhcityinfo:delete']">删除</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="cityCode" label="城市编码" min-width="100px"></el-table-column>
                <el-table-column prop="sort" label="排序" min-width="100px"></el-table-column>
                <el-table-column prop="cityName" label="城市名称" min-width="100px"></el-table-column>
                <el-table-column prop="cityEn" label="城市英文名称" min-width="100px"></el-table-column>
                <el-table-column label="城市图片" min-width="100px">
                    <template slot-scope="{row}">
                        <el-image
                            v-if="row.cityPic"
                            style="width: 80px; height: 80px"
                            :src="baseUrl + row.cityPic"
                            fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['renthouse:rhcityinfo:update', 'renthouse:rhcityinfo:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaRhCityInfoWindow.open('编辑城市', row)" icon="el-icon-edit" v-permissions="['renthouse:rhcityinfo:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['renthouse:rhcityinfo:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaRhCityInfoWindow ref="operaRhCityInfoWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRhCityInfoWindow from '@/components/rentHouse/OperaRhCityInfoWindow'
export default {
  name: 'RhCityInfo',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRhCityInfoWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        cityName: '',
        cityCode: '',
        display: 1
      },
      baseUrl: process.env.VUE_APP_API_IMG
    }
  },
  created () {
    this.config({
      module: '开通城市信息',
      api: '/rentHouse/rhCityInfo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
